import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import CompetitorInformation from "./competitorInformation";

function mapStateToProps(state) {
  return {
    domainDetails: state.domainDetails,
    machines: state.machines,
    bids: state.bids,
    transactions: state.transactions,
    transactionRequest: state.transactionRequest,
    errorFields: state.onSubmitDetails.errorFields,
    errorFlag: state.onSubmitDetails.errorFlag,
    actionType: state.actionType,
    texts : state.translatedTexts
  };
}

function mapDispatchToProps(dispatch) {
  let actionDispatchers = bindActionCreators(actionCreators, dispatch);
  return actionDispatchers;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompetitorInformation);
